import { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomRadioBtn from "../../base/CustomRadioBtn";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { VmNetworkTypeDropdownItem } from "./VmNetworkData";
import { CustomCircleCheckBox } from "../../base/CustomCheckBox";
import CustomText from "components/base/CustomText";
import { checkFormatAllow } from "common/util";



interface VmNetworkAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

VmNetworkAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function VmNetworkAdd(props:VmNetworkAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    
    const [vmNetworkName, setVmNetworkName] = useState("");
    const [vmNetworkDesc, setVmNetworkDesc] = useState("");
    const [vmNetworkType, setVmNetworkType] = useState("FLAT");
    const [vmPhysicalNetworkName, setVmPhysicalNetworkName] = useState("");
    
    const [vmNetworkPubType, setVmNetworkPubType] = useState("PUB");
    const [externalYn, setExternalYn] = useState(false);
    const [vlanId, setVlanId] = useState("");

    const [targetId, setTargetId] = useState("");
    const [projectList, setProjectList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [vmNetworkNameWarnYn, setVmNetworkNameWarnYn] = useState(false);
    const [vmPhysicalNetworkNameWarnYn, setVmPhysicalNetworkNameWarnYn] = useState(false);
    const [vlanIdWarnYn, setVlanIdWarnYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkVmNetworkData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
            
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(vmNetworkPubType === "PRJ") {
            loadProjectList()
        }
    }, [vmNetworkPubType])


    useEffect(() => {
        if(executeAddYn) {
            executeAddVmNetwork();
        }
    }, [executeAddYn]);

    function checkVmNetworkData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        
        setVmNetworkNameWarnYn(false);
        setVmPhysicalNetworkNameWarnYn(false);
        setVlanIdWarnYn(false);
        let message = "";
        let error = false;
        if(!vmNetworkName) {
            message = t("MESSAGE_VM_NETWORK_INFO_ENTER_ERROR_MESSAGE")
            if(!vmNetworkName) {
                setVmNetworkNameWarnYn(true);    
            }
            error = true;
        }
        if(vmNetworkType === "FLAT" && !vmPhysicalNetworkName) {
            message = t("MESSAGE_VM_NETWORK_INFO_ENTER_ERROR_MESSAGE")
            setVmPhysicalNetworkNameWarnYn(true);    
            error = true;
        }
        if(vmNetworkType === "GENEVE" && (!vlanId || checkFormatAllow(vlanId, ["number"]) === false || Number(vlanId) < 1024 || Number(vlanId) > 65535)) {
            message = t("MESSAGE_VM_NETWORK_INFO_ENTER_ERROR_MESSAGE")
            setVlanIdWarnYn(true);    
            error = true;
        }

        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }
    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setProjectList(response.data.items.map((data, index) => {
                    return { value: data.project_id, label: data.project_name };
                }));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function executeAddVmNetwork() {
        const addPackageData = {
            network: {
                network_name: vmNetworkName,
                network_description: vmNetworkDesc,
                network_type_code: vmNetworkType,
                share_type_code: vmNetworkPubType,
                physical_network_name: vmNetworkType==="FLAT" ? vmPhysicalNetworkName : "",
                vlan_id: vmNetworkType==="GENEVE" ? Number(vlanId) || 0 : 0,
                external_yn: externalYn,
                up_yn: true,
                all_availability_zone_yn:true
            },
            availability_zones:[]
        }
        
        if(vmNetworkPubType === "PRJ") {
            addPackageData["project"] = {
                project_id: targetId
            }
        }

        requests.post(PLATFORM_URL.VM_NETWORK, addPackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_NETWORK_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_NETWORK_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }
    function selectButton(id, type){
        setVmNetworkPubType(type);
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("VM_NETWORK_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("NETWORK_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={2} 
                                width={570} height={36} 
                                value={vmNetworkName} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setVmNetworkName} 
                                warnYn={vmNetworkNameWarnYn} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea 
                                key={3} 
                                width={570} 
                                height={100} 
                                value={vmNetworkDesc} 
                                type={"text"} 
                                activeYn={true}
                                inputCb={setVmNetworkDesc} 
                                warnYn={false} 
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("NETWORK_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown 
                                key={5} 
                                width={300} height={36} 
                                items={VmNetworkTypeDropdownItem}
                                setValue={setVmNetworkType} 
                                disable={false}
                                defaultvalue={{value: "FLAT", label: "FLAT"}}
                            />
                        </View>
                        {
                            vmNetworkType === "FLAT"
                            ?<Fragment>
                            <View style={style.rowContainer}>
                                <CustomText text={t("PHYSICAL_NETWORK_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomTextInput 
                                    key={11} 
                                    width={570} height={36} 
                                    value={vmPhysicalNetworkName} 
                                    type={"text"} 
                                    activeYn={vmNetworkType==="FLAT"} 
                                    inputCb={setVmPhysicalNetworkName} 
                                    warnYn={vmPhysicalNetworkNameWarnYn} 
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                            <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                                {t("DESCRIBE_NETWORK_PHYSICAL_NETWORK_SELECT")}
                            </Text>
                            </Fragment>
                            :
                            <Fragment>
                            <View style={style.rowContainer}>
                                <CustomText text={t("VM_NETWORK_VLAN_ID_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomTextInput 
                                    key={22} 
                                    width={110} height={36} 
                                    value={vlanId} 
                                    type={"number"} 
                                    activeYn={vmNetworkType==="GENEVE"} 
                                    inputCb={setVlanId} 
                                    warnYn={vlanIdWarnYn} 
                                    placeHolderText={"0"}
                                />
                            </View>
                            <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                                {t("DESCRIBE_NETWORK_VLAN_ID_SELECT")}
                            </Text>
                            </Fragment>
                        }
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("EXTERNAL_NETWORK_CONNECT_TEXT")}
                            </Text>
                            <CustomCircleCheckBox 
                                id="ExternalYn"
                                key={33} 
                                checked={externalYn}
                                setCheckBoxStatus={(e) => {setExternalYn(!externalYn)}}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SHARE_CATEGORY_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomRadioBtn 
                                id={"InstanceShareType"} 
                                type={"PUB"} 
                                size={18} 
                                checked={vmNetworkPubType === "PUB" ? true: false} 
                                selectCb={selectButton} 
                                label={"공용(Pubilc)"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            <CustomRadioBtn 
                                id={"InstanceShareType"} 
                                type={"PRJ"} 
                                size={19} 
                                checked={vmNetworkPubType === "PRJ" ? true: false} 
                                selectCb={selectButton} 
                                label={"개인(프로젝트)"}
                                labelStyle={labelStyle}
                            />
                        </View>
                        {
                            vmNetworkPubType !== "PUB" ?
                            <View style={style.rowContainer}>
                                <CustomText text={t("PROJECT_INFO_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomDropDown 
                                    key={10} 
                                    width={300} height={36} 
                                    items={projectList}
                                    setValue={setTargetId} 
                                    disable={false}
                                    defaultvalue={{label:"", value:""}}
                                />
                            </View>
                            : null
                        }
                    </View>
                </View> 
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}